// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2Zpy{padding:1.6rem 2rem;display:flex;flex-wrap:wrap}._3hg0{width:100%;margin:0 auto 1.6rem}@media (min-width:36em){._3hg0{width:11rem;margin:0 2rem 0 0}}._1GY9{display:block;margin:0 auto}@media (min-width:36em){._1GY9{margin:auto}}._3cgE{flex:1}._3cgE .h5{margin:0}._3BkU,._3cgE .p2{margin:.8rem 0 0}._3BkU{min-width:24rem;min-height:0;text-align:center;display:table}@media (min-width:36em){._3BkU{margin:.8rem 0 0 auto}}@media (min-width:36em){html[dir=rtl] ._3hg0{margin:0 0 0 2rem}}@media (min-width:36em){html[dir=rtl] ._3BkU{margin:.8rem auto 0 0}}", ""]);
// Exports
exports.locals = {
	"item": "_2Zpy",
	"imgWrapp": "_3hg0",
	"img": "_1GY9",
	"content": "_3cgE",
	"btn": "_3BkU"
};
module.exports = exports;
